import Workingolf from './workingolf'
import WorkingolfPageQuery, { WORKINGOLF_QUERY } from './workingolf.query'

export { WorkingolfPageQuery, WORKINGOLF_QUERY }

export default Workingolf
